import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getStoredConsent, saveAnalyticsConsent, updateAnalyticsConsent } from "../lib/analytics";

export default function AnalyticsConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;

    hasInitialized.current = true;
    const savedConsent = getStoredConsent();

    if (savedConsent) {
      updateAnalyticsConsent(savedConsent === "granted");
      return;
    }

    setIsVisible(true);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("google-consent-open", isVisible);

    return () => document.body.classList.remove("google-consent-open");
  }, [isVisible]);

  useEffect(() => {
    const openConsentSettings = () => setIsVisible(true);
    window.addEventListener("pimp-open-consent", openConsentSettings);

    return () => window.removeEventListener("pimp-open-consent", openConsentSettings);
  }, []);

  const saveConsent = (granted) => {
    saveAnalyticsConsent(granted);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <section
      className="google-consent-banner"
      role="region"
      aria-live="polite"
      aria-label="Consentement aux cookies"
      data-testid="analytics-consent-banner"
    >
      <p>
        Nous utilisons Google Analytics 4 (mesure d’audience) et Google Ads (suivi des conversions publicitaires). Aucun cookie n’est déposé avant votre accord.
        {" "}
        <Link to="/confidentialite" className="consent-privacy-link" data-testid="analytics-consent-privacy-link">
          En savoir plus
        </Link>
      </p>
      <div>
        <button
          className="consent-refuse-button"
          onClick={() => saveConsent(false)}
          data-testid="analytics-consent-refuse-button"
        >
          Refuser
        </button>
        <button
          className="consent-accept-button"
          onClick={() => saveConsent(true)}
          data-testid="analytics-consent-accept-button"
        >
          Accepter
        </button>
      </div>
    </section>
  );
}